<template>
    <nav class="mb-32">
        <ul>
            <li class="breadcrumb"
                v-for="(breadcrumb, index) in breadcrumbs" :key="index"
            >
                <a class="breadcrumb__link" :href="breadcrumb.url">
                    <span v-if="isTablet">
                        {{ $t('breadcrumbs.see') }}
                    </span>
                    {{ breadcrumb.name }}
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    props: {
        breadcrumbs: {
            type: Array,
            default: [
                {
                    name: 'Home',
                    url: '/'
                }
            ]
        }
    },
    data() {
        return {
            isTablet: null,
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.isTablet = window.innerWidth <= 768;
        }
    }
};
</script>
